import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-view container",
  role: "main"
}
const _hoisted_2 = { class: "col-12 col-md-6 input-voucher-column" }
const _hoisted_3 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "d-flex flex-row justify-content-center align-items-center gap-2" }
const _hoisted_6 = { class: "col-12 col-md-6 accordion-voucher-column pb-md-5z" }
const _hoisted_7 = {
  id: "AccordionWhatsVoucher",
  class: "accordion"
}
const _hoisted_8 = { class: "accordion-item" }
const _hoisted_9 = {
  id: "AccordionAnswerDontHaveVoucher",
  class: "accordion-collapse collapse",
  "aria-labelledby": "AccordionQuestionDontHaveVoucher",
  "data-bs-parent": "#AccordionWhatsVoucher"
}
const _hoisted_10 = { class: "accordion-body" }
const _hoisted_11 = { class: "m-0 text-start" }
const _hoisted_12 = { class: "m-0 text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ModalRFB = _resolveComponent("ModalRFB")!
  const _component_ModalRFBError = _resolveComponent("ModalRFBError")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs),
    _createVNode(_component_Wizzard, { "current-page": "voucher" }),
    _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "d-flex" }, "Emissão de Certificado", -1)),
    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "span-tip d-flex mb-3" }, " Para emitir um Certificado a partir de um Bird ID, será necessário digitar o código do Voucher do Certificado adquirido. ", -1)),
    _createElementVNode("div", {
      class: "d-flex row col-12 me-0 ms-0",
      onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["enter"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "d-flex" }, "Nº Voucher/Pedido*", -1)),
        _createVNode(_component_Input, {
          modelValue: _ctx.voucher,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.voucher) = $event)),
          class: "input-voucher mt-2 w-100",
          icon: "tag",
          placeholder: "Digite o código do Voucher/Pedido",
          "error-log": _ctx.error
        }, null, 8, ["modelValue", "error-log"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn-next-page btn btn-primary d-flex justify-content-around mt-2 align-self-end", [!_ctx.isValid ? 'btn-secondary' : 'btn-primary']]),
            type: "button",
            disabled: !_ctx.isValid,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "Avançar", -1)),
              _createVNode(_component_Icon, { name: "arrow-right" })
            ])
          ], 10, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"accordion-item\" data-v-0a691e03><div id=\"AccordionQuestionVoucher\" class=\"accordion-header\" data-v-0a691e03><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#AccordionAnswerVoucher\" aria-controls=\"AccordionAnswerVoucher\" data-v-0a691e03> O que é um Voucher? </button></div><div id=\"AccordionAnswerVoucher\" class=\"accordion-collapse collapse\" aria-labelledby=\"AccordionQuestionVoucher\" data-bs-parent=\"#AccordionWhatsVoucher\" data-v-0a691e03><div class=\"accordion-body\" data-v-0a691e03><p class=\"m-0 text-start\" data-v-0a691e03> O voucher é um código que você recebe de uma empresa <br data-v-0a691e03>para emitir seu Certificado <br data-v-0a691e03>Digital, como por exemplo, seu contador ou a empresa onde você trabalha. O voucher <br data-v-0a691e03>tem 12 caracteres e é um misto de números e letras. Ex: 001c70fxxxxx. </p></div></div></div><div class=\"accordion-item\" data-v-0a691e03><div id=\"AccordionQuestionWhereRequestNumber\" class=\"accordion-header\" data-v-0a691e03><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#AccordionAnswerWhereRequestNumber\" aria-expanded=\"false\" aria-controls=\"AccordionAnswerWhereRequestNumber\" data-v-0a691e03> Onde encontro o número do Pedido? </button></div><div id=\"AccordionAnswerWhereRequestNumber\" class=\"accordion-collapse collapse\" aria-labelledby=\"AccordionQuestionWhereRequestNumber\" data-bs-parent=\"#AccordionWhatsVoucher\" data-v-0a691e03><div class=\"accordion-body\" data-v-0a691e03><p class=\"m-0 text-start\" data-v-0a691e03> O número do pedido é um número que você recebe assim <br data-v-0a691e03>que efetua uma compra em <br data-v-0a691e03>nosso e-commerce. Este número vai por e-mail junto com as informações de compra <br data-v-0a691e03>e geralmente está contido também no assunto do e-mail. </p></div></div></div>", 2)),
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("div", {
              id: "AccordionQuestionDontHaveVoucher",
              class: "accordion-header"
            }, [
              _createElementVNode("button", {
                class: "accordion-button collapsed",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#AccordionAnswerDontHaveVoucher",
                "aria-expanded": "false",
                "aria-controls": "AccordionAnswerDontHaveVoucher"
              }, " Não tenho um Voucher Nº do Pedido, e agora? ")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "m-0 text-start" }, " Ainda não tem um voucher ou um número de pedido? ", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "m-0 text-start" }, " Entre em contato conosco e adquira! ", -1)),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.arData.foneAR), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.arData.siteAR
                      .replace('https://', '')
                      .replace('http:/', '')
                      .replace('/', '')), 1)
              ])
            ])
          ])
        ])
      ])
    ], 32),
    _createVNode(_component_ModalRFB, {
      ref: "modalRfbRef",
      "create-solicitation": _ctx.createSolicitation,
      request: _ctx.model
    }, null, 8, ["create-solicitation", "request"]),
    _createVNode(_component_ModalRFBError, { ref: "modalRfbRefError" }, null, 512)
  ]))
}